export default __webpack_public_path__ + "static/media/tel-icon-pink.0a5e9d2c.svg";